import api from './api';

/** Recetas elaboradas (API /recetas/platos). */
const recetaPlatoService = {
  async list(params = {}) {
    const response = await api.get('/recetas/platos', { params });
    return response.data;
  },

  async exportDetalle(params = {}) {
    const response = await api.get('/recetas/platos/export/detalle', { params });
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/recetas/platos/${id}`);
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/recetas/platos', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/recetas/platos/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/recetas/platos/${id}`);
    return response.data;
  },

  async reporteUsoInsumo(productId) {
    const response = await api.get('/recetas/reportes/uso-insumo', {
      params: { product_id: productId },
    });
    return response.data;
  },
};

export default recetaPlatoService;
